import { useMemo } from 'react'

export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    return JSON.parse(data)
      .filter(item => !item.matched)
      .map(item => ({
        ...item,
        selected: item.type === 'MATCH',
        id: item.external.id,
      }))
  }, [data])
}
